<template>
    <div
        class="py-5"
        :style="{
            'border-color': faq.borderColor,
        }"
    >
        <dt class="text-lg">
            <cUtilsEdit @edit="goToQuestionField(question.id, 'questionQuestion')">
                <h4
                    class="font-semibold text-gray-900"
                    :class="[
                        faq.textAlign == 'right'
                            ? 'text-right'
                            : faq.textAlign == 'center'
                              ? 'text-center'
                              : 'text-left',
                    ]"
                    :style="{
                        color: faq.questionColor,
                        'font-size': faq.questionSize + 'px',
                    }"
                    v-html="questionQuestion"
                    key=""
                ></h4>
            </cUtilsEdit>
        </dt>
        <dd class="mt-2">
            <cUtilsEdit @edit="goToQuestionField(question.id, 'questionAnswer')">
                <p
                    class="text-base text-gray-500 opacity-80"
                    :style="{
                        color: faq.questionColor,
                        'font-size': faq.questionSize + 'px',
                    }"
                    :class="[
                        faq.textAlign == 'right'
                            ? 'text-right'
                            : faq.textAlign == 'center'
                              ? 'text-center'
                              : 'text-left',
                    ]"
                    v-html="questionAnswer"
                ></p>
            </cUtilsEdit>
        </dd>
    </div>
</template>

<script>
import cUtilsEdit from "@/views/shared/cUtilsEdit.vue";
import { useFaqGoTo } from "@/views/tools/faq/utils/useFaqGoTo";

export default {
    name: "ColumnsQuestion",
    props: {
        faq: Object,
        question: Object,
        query: String,
    },
    setup() {
        const { goToQuestionField } = useFaqGoTo();
        return {
            goToQuestionField,
        };
    },
    components: {
        cUtilsEdit,
    },
    computed: {
        questionQuestion() {
            return this.query
                ? this.highlightText(this.query, this.question.question)
                : this.question.question;
        },
        questionAnswer() {
            return this.query
                ? this.highlightText(this.query, this.question.answer)
                : this.question.answer;
        },
    },
    methods: {
        highlightText(query, text) {
            const myReg = new RegExp("(" + query + ")", "gi");
            return text.replace(myReg, "<span style='background: yellow'>$1</span>");
        },
    },
};
</script>
